import i18n from "@/i18n";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { PasswordRequirements } from "../../data/passwordRequirements";
import { OperationModel } from "../operations/operationModel";
import { EventCode } from "../../data/enums/eventCode";

/** Модель ссмены пароля */
export class ChangePasswordModel extends OperationModel {
  /**Заголовок операции */
  Caption: string = i18n.t("main.settings.changePassword").toString();
  /** Действующий пароль */
  Password: string = "";

  /**Правила заполнения действующего пароля */
  PasswordRules: Array<any> = [
    (p: any) => !!p || i18n.t("main.settings.errors.passwordEmpty"),
    (p: any) =>
      (p && p.length <= 200) || i18n.t("main.settings.errors.passwordMaxLength")
  ];

  /**Признак отображения старого пароля */
  ShowPassword: boolean = false;

  /** Новый пароль */
  NewPassword: string = "";
  /**Правила заполнения нового пароля */
  NewPasswordRules: Array<any> = [];
  /**Признак отображения нового пароля */
  ShowNewPassword: boolean = false;

  /** Подтверждение пароля */
  ConfirmPassword: string = "";
  /**Признак подтверждения пароля */
  ShowСonfirmPassword: boolean = false;

  /**Требования к паролю */
  public passwordRequirements: PasswordRequirements = new PasswordRequirements();

  /**Вычисляем метод проверки нового пароля*/
  public NewPasswordRule = () => {
    const isValidPassword = (this.passwordRequirements as PasswordRequirements)
      .SatisfactoryPassword
      ? new RegExp(
          (this
            .passwordRequirements as PasswordRequirements).SatisfactoryPassword
        ).test(this.NewPassword)
      : true;
    return isValidPassword || i18n.t("main.settings.errors.passwordBad");
  };

  /**Проверяем, не повторяет ли новый пароль старый*/
  public NewPasswordAsOldRule = () => {
    return (
      this.Password != this.NewPassword ||
      i18n.t("main.settings.errors.newAndOldPasswordsEqual")
    );
  };

  /**Вычисляем метод проверки подтверждения пароля*/
  public ConfirmPasswordRule = () => {
    return (
      this.ConfirmPassword == this.NewPassword ||
      i18n.t("main.settings.errors.passwordsNotEqual")
    );
  };

  /**Вычисляем признак удовлетворителного пароля */
  get NormalPassword(): boolean {
    return (
      (this.passwordRequirements.SatisfactoryPassword
        ? new RegExp(this.passwordRequirements.SatisfactoryPassword).test(
            this.NewPassword
          )
        : true) && this.NewPassword != this.Password
    );
  }

  /**Вычисляем признак сильного пароля */
  get StrongPassword(): boolean {
    return (
      (this.passwordRequirements.StrongPassword
        ? new RegExp(this.passwordRequirements.StrongPassword).test(
            this.NewPassword
          )
        : false) && this.NewPassword != this.Password
    );
  }

  constructor(passwordRequirements: PasswordRequirements) {
    super();
    this.passwordRequirements = passwordRequirements;
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;
    ord.operationId = this.OperationId;
    ord.EventCode = EventCode.ChangePassword;

    ord.setProperty(
      "newPassword",
      this.NewPassword,
      DeclarationPropertiesTypes.String
    );
    ord.setProperty(
      "oldPassword",
      this.Password,
      DeclarationPropertiesTypes.String
    );

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(...args: any[]): void {
    console.log("No implemetation");
  }
}
